import {useEffect, useState} from 'react';

const useIsInSalesforce = (): boolean => {
    const [isInSalesforce, setIsInSalesforce] = useState(false);

    useEffect(() => {
        const hasSalesforceClasses =
            document.body.classList.contains('salesforce') &&
            document.body.classList.contains('canvas');

        setIsInSalesforce(hasSalesforceClasses);
    }, []);

    return isInSalesforce;
};

export default useIsInSalesforce;
